import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { useMemo } from "react";

export const isQuoteRequired = (productContext: ProductContextModel | CartLineModel): boolean => {
    if (productContext && "product" in productContext) {
        return productContext.product?.quoteRequired || productContext.productInfo?.pricing?.actualPrice === 0;
    }
    return productContext.quoteRequired || productContext.pricing?.actualPrice === 0;
};

const useCustomQuoteRequired = (productContext: ProductContextModel | CartLineModel): boolean => {
    return useMemo(() => isQuoteRequired(productContext), [productContext]);
};

export default useCustomQuoteRequired;
